"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnect = void 0;
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_loader_spinner_1 = __importDefault(require("react-loader-spinner"));
var components_1 = require("../components");
var useWalletConnectConnector_1 = require("../connectors/useWalletConnectConnector");
var WalletConnect = function (_a) {
    var onSubmit = _a.onSubmit;
    var uri = useWalletConnectConnector_1.useWalletConnectConnector(onSubmit, react_device_detect_1.isAndroid);
    return (react_1.default.createElement("div", { className: "tw-flex tw-flex-col tw-items-center" },
        react_1.default.createElement("h1", { className: "tw-text-lg dark:tw-text-gray-200 tw-font-medium" }, "WalletConnect"),
        react_1.default.createElement("div", { className: "tw-w-64 md:w-80 tw-text-gray-600 dark:tw-text-gray-400 tw-text-sm tw-mt-2 tw-text-center" }, "Scan the QR code below or copy-paste the information into your wallet."),
        react_1.default.createElement("div", { className: "tw-mt-6" }, uri ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(qrcode_react_1.default, { value: uri, size: react_device_detect_1.isMobile ? 180 : 240 }),
                react_1.default.createElement("div", { className: "tw-mt-6 tw-flex tw-items-center tw-justify-center" },
                    react_1.default.createElement(components_1.CopyText, { text: "Copy to clipboard", payload: uri }))))) : (react_1.default.createElement("div", { className: "tw-my-8 tw-flex tw-items-center tw-justify-center" },
            react_1.default.createElement(react_loader_spinner_1.default, { type: "TailSpin", color: "#666666", height: "60px", width: "60px" }))))));
};
exports.WalletConnect = WalletConnect;
//# sourceMappingURL=wallet-connect.js.map